import { DatePipe } from '@angular/common';
import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { Campaign3BreadcrumbComponent } from 'app/views/campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component';
import { Acm } from 'app/models/loyalty-acm.model';
import { Permission } from 'app/models/permission.model';
import { LoyaltyAcmService } from 'app/services/loyalty/loyalty-acm.service';
import { LoyaltyChannelService } from 'app/services/loyalty/loyalty-channel.service';
import { LoyaltyAcmTypeService } from 'app/services/loyalty/loyalty-acm-type.service';
import { AuthService } from 'app/services/user/auth.service';
import { PermsService } from 'app/services/utils/perms.service';
import { Accumulator3Service } from 'app/views/campaign-3/services/accumulator3.service';
import { MessageService } from 'primeng/primeng';

@Component({
  selector: 'app-loyalty-acm-3',
  templateUrl: './loyalty-acm-3.component.html',
  styleUrls: ['./loyalty-acm-3.component.css']
})
export class LoyaltyAcm3Component implements OnInit {

  columsTitles: any;
  totalRecords = 0;
  acms: Array<Acm>;
  acmModal: Acm;
  showModalDelete: boolean;
  sortO: number;
  sortF: string;
  listChannelsSelect: Array<{ value: string, label: string }>;
  listAcmTypes: Array<{ value: string, label: string }>;
  listStates: Array<{ value: string, label: string }>;
  listActivationStates: Array<{ value: string, label: string }>;
  datePipe: DatePipe;
  currentOpenedRow;

  private lastLoadParam: { offset: number, limit: number, search?: Array<{ key: string, value: string }> };

  // Mostra i tasti di edit, delete e recover
  public acmPermission: Permission;

  paginationType = Campaign3KontableComponent.ServerPagination;
  breadcrumbs: Array<BreadCrumbModel> = [];
  @ViewChild('acmTable') kontableComponent: Campaign3KontableComponent;
  @ViewChild('breadcrumbComponent') breadcrumb: Campaign3BreadcrumbComponent;
  selectFilter = Campaign3KontableComponent.SelectFilter;
  customFilter = Campaign3KontableComponent.CustomFilter;
  noFilter = Campaign3KontableComponent.NoFilter;

  newDataAvailable = false;
  showMenu = false;
  readyTable: boolean = false;
  expandTable: boolean = false;
  fetchActionListAsap: boolean = false;


  constructor(
    private translate: TranslateService,
    public acmService: LoyaltyAcmService,
    private channelService: LoyaltyChannelService,
    private acmTypeService: LoyaltyAcmTypeService,
    private acmService2: Accumulator3Service,
    private router: Router,
    private authService: AuthService,
    private permissionService: PermsService,
    public srvCalendar: CalendarTranslateService,
    private srvNotify: MessageService
  ) { }



  ngOnInit() {
    this.sortO = 1;
    this.sortF = '';
    this.listChannelsSelect = [];
    this.listAcmTypes = [];
    this.listStates = [];
    this.listActivationStates = [];

    this.listChannelsSelect.push({ label: '', value: null });
    this.listAcmTypes.push({ label: '', value: null });
    this.listStates.push({ label: '', value: null });
    this.listActivationStates.push({ label: '', value: null });

    this.initBreadCrumbs();

    this.permissionService.getPermission({ ms_base: 'koncentro-loyalty', operation: 'acm' }).subscribe(res => {
      this.acmPermission = res;
    });



    this.translate.get([
      'acm.channel_id',
      'acm.acm_code',
      'acm.acm_type_id',
      'acm.description',
      'common.all',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended',
      'date_end',
      'date_start',
      'acm.valid',
      'acm.expired',
      'acm.future'
    ]).subscribe((translations) => {
      this.columsTitles = {
        channel_id: translations['acm.channel_id'],
        acm_code: translations['acm.acm_code'],
        acm_type_id: translations['acm.acm_type_id'],
        description: translations['acm.description']
      };

      this.listActivationStates.push({ label: translations['acm.valid'], value: 'valid' });
      this.listActivationStates.push({ label: translations['acm.expired'], value: 'expired' });
      this.listActivationStates.push({ label: translations['acm.future'], value: 'future' });

      this.listStates.push({ label: translations['common.status_notDeleted'], value: '0' });
      this.listStates.push({ label: translations['common.status_onlyDeleted'], value: '1' });
      this.listStates.push({ label: translations['common.status_onlySuspended'], value: '2' });

    });

    this.channelService.list().subscribe((res) => {
      for (const channel of res.data) {
        this.listChannelsSelect.push({ value: channel.id.toString(), label: channel.channelDescription });
      }
      // Ordina alfabeticamente la lista dei canali
      this.listChannelsSelect.sort((a, b) => a.label.localeCompare(b.label));
    });

    this.acmTypeService.list().subscribe((res) => {
      for (const acmType of res.data) {
        this.listAcmTypes.push({ value: acmType.description, label: acmType.description });
      }
    });

    //da decidere se mostrare dettaglio con parametro o meno il parametro o meno
    //for now giocare con i valori per vedere il risultato



    const multipleChannelSub = this.acmService.checkIfMultipleChannel();

    multipleChannelSub.subscribe(
      res => {

        console.log(res.flg_state);
        /*
              //TODO
              //provvisorio per test DA ELIMINARE !!!
              this.expandTable=true;
              this.fetchActionListAsap=false; */

        if (res.flg_state === "0") {
          this.expandTable = true;
          //comportamento dentro l'espansione
          this.fetchActionListAsap = false;
        }
      }
    )


    this.readyTable = true;
    //non riesco a valorizzare il campo ma riesco a ricercare con i parametri corretti, non ho ancora impostato la sort direction
    setTimeout(() => {
      let filterobject = { key: "status", value: "valid", filterType: "equals" };
      this.kontableComponent.filter.search.push(filterobject);
      this.kontableComponent.filter.sort = "dateStart";
      this.kontableComponent.filter.sort_dir = -1;

      this.kontableComponent.refresh();
      this.kontableComponent.filter.search = [];

    }, 100);


  }

  // Aggiungi il listener agli eventi del documento
  @HostListener('document:click', ['$event'])
  onClick(event: any) {
    // Verifica se il clic è avvenuto al di fuori del dropdown-menu aperto
    if (!event.target.closest('.dropdown-menu') && event.target.closest('.d-flex') === null) {
      this.showMenu = false;
    }
  }

 
  //TODO chiedere che valore mostrare
  getAcmStatus(row: any) {
    let elabrow = this.listStates.find(x => x.value == row.flg_state)
    let retVal = "";
    if (elabrow) {
      retVal = elabrow.label;

    }
    return retVal;
  }
  checkExpiredAcm(acm) {

    let res = null;
    let language = this.authService.sessionHelper.selectedLanguage;
    let dateStart: Date;
    let dateEnd: Date;
    let now = new Date();

    if (language == 'it') {
      // formato dd/MM/yyyy
      dateStart = new Date(acm.dateStart.substr(6, 4), +acm.dateStart.substr(3, 2) - 1, acm.dateStart.substr(0, 2));
      dateEnd = new Date(acm.dateEnd.substr(6, 4), +acm.dateEnd.substr(3, 2) - 1, acm.dateEnd.substr(0, 2));
    } else {
      // formato yyyy-MM-dd
      dateStart = new Date(acm.dateStart.substr(0, 4), +acm.dateStart.substr(5, 2) - 1, acm.dateStart.substr(8, 2));
      dateEnd = new Date(acm.dateEnd.substr(0, 4), +acm.dateEnd.substr(5, 2) - 1, acm.dateEnd.substr(8, 2));
    }

    if (dateStart <= now && dateEnd >= now) {
      res = 'valid';
    } else if (dateEnd < now) {
      res = 'expired';
    } else if (dateStart > now) {
      res = 'future';
    }


    return res;

  }
  initBreadCrumbs() {
    let bc1 = new BreadCrumbModel();
    bc1.code = "acm1";
    bc1.description = "Accumulatori";
    bc1.routerLink = "/loyalty3/acm";
    this.breadcrumbs.push(bc1);
  }
  //TODO decidere dove mi porta il click
  breadcrumbClicked(breadbrumb: BreadCrumbModel) {
    if (breadbrumb.routerLink) {
      // Correzione qui
      this.router.navigate([breadbrumb.routerLink]);
    } else {
      console.log("nessuna route implementata");
    }
  }

  onAddAccumulator() {
    this.router.navigate(['/loyalty3/acm/form/']);
  }

  //nuovo edit
  onOpenEdit(acm: Acm) {
    this.router.navigate(['/loyalty3/acm/form/' + acm.id]);
  }
  //nuovo info
  onOpenInfo(acm: Acm) {

  }
  //nuovo Delete
  onDelete(acm: Acm) {

  }
  a1() {

  }
  a2() {

  }
  //todo quando clicco fuori deve chiudersi
  toggleMenu(id: number) {

    if (this.showMenu && this.currentOpenedRow !== id) {
      this.showMenu = false;
    }

    this.currentOpenedRow = id;
    this.showMenu = !this.showMenu;
  }

  edit(acm: Acm) {
    this.router.navigate(['/loyalty3/acm/form/' + acm.id]);
  }

  add() {
    this.router.navigate(['/loyalty3/acm/form/']);
  }

  openDeleteModal(acm) {
    this.acmModal = acm;
    this.showModalDelete = true;
  }

  remove(acm) {
    this.showModalDelete = false;
    this.acmService.remove(acm.id).subscribe((res) => {
      // this.loadPage(this.lastLoadParam.offset, this.lastLoadParam.limit, this.lastLoadParam.search);
      this.newDataAvailable = true;
    });
  }

  recover(acm) {
    this.acmService.recover(acm).subscribe((res) => {

      this.newDataAvailable = true;
      // this.loadPage(this.lastLoadParam.offset, this.lastLoadParam.limit, this.lastLoadParam.search);

    });
  }

  changeSort(event) {
    this.sortF = event.field;
  }

  /*
  getStatus(dateStart, dateEnd): string{
    let status = null;

    let language = this.authService.sessionHelper.selectedLanguage;
    let today: string;
    if(language == "it"){
      today = this.datePipe.transform(new Date(),'dd/MM/yyyy');
    }
    else{
      today = this.datePipe.transform(new Date(),'yyyy/MM/dd');
    }

    //if(dateStart > today);
    return status;
  }
  */

  getStatus(acm): string {

    let res = null;
    let language = this.authService.sessionHelper.selectedLanguage;
    let dateStart: Date;
    let dateEnd: Date;
    let now = new Date();

    if (language == 'it') {
      // formato dd/MM/yyyy
      dateStart = new Date(acm.dateStart.substr(6, 4), +acm.dateStart.substr(3, 2) - 1, acm.dateStart.substr(0, 2));
      dateEnd = new Date(acm.dateEnd.substr(6, 4), +acm.dateEnd.substr(3, 2) - 1, acm.dateEnd.substr(0, 2));
    } else {
      // formato yyyy-MM-dd
      dateStart = new Date(acm.dateStart.substr(0, 4), +acm.dateStart.substr(5, 2) - 1, acm.dateStart.substr(8, 2));
      dateEnd = new Date(acm.dateEnd.substr(0, 4), +acm.dateEnd.substr(5, 2) - 1, acm.dateEnd.substr(8, 2));
    }

    if (dateStart <= now && dateEnd >= now) {
      res = 'valid';
    } else if (dateEnd < now) {
      res = 'expired';
    } else if (dateStart > now) {
      res = 'future';
    }

    return res;
  }

  refreshAfterCreate(fatherRow) {

    this.kontableComponent.fetchAcmList(fatherRow);
  }

  checkAlreadyDeleted(row) {
    return row.flg_state === "1";
  }
  
  accToDelete: Acm
  displayDeleteDialog: boolean = false;
  deleteAccumulator(row: any) {
    this.accToDelete = row;
    this.acmService2.getAcmLoyChannelList(row.id).subscribe(
      (res) => {

        if (res && res.length == 0) {
          this.displayDeleteDialog = true;
        } else {
          this.srvNotify.add({
            severity: 'error',
            summary: this.translate.instant('common.error'),
            detail: this.translate.instant('acm.impossible_to_delete')
          });

        }
      },
      (error) => {
        console.error('Errore durante il recupero di azioni delle campagne:', error);
      }
    );
  }

  onDefinitiveDelete(row: any) {
    this.acmService2.deleteFatherAcm(row.id).subscribe(() => {
      this.displayDeleteDialog = false;
      this.srvNotify.add({
        severity: 'success',
        summary: this.translate.instant('common.success'),
        detail: this.translate.instant('acm.delete_fatheracm_ok'),
        life: 5000
      });
      this.kontableComponent.refresh();
    });
  }

  closePopupDelete() {
    this.displayDeleteDialog = false;
  }


}



// WEBPACK FOOTER //
// ./src/app/views/loyalty-3/loyalty-acm-3/loyalty-acm-3.component.ts